import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';

class DebitOrCredit extends React.Component {
  render() {
    const guestMessages = localsMessages('guest/payCreditOrDebit') || {};
    const payCreditOrDebit =
      (guestMessages.label && guestMessages.label.payCreditOrDebit) || '';

    return (
      <div className="ppvx_row" style={{ maxWidth: 400, margin: '0 auto' }}>
        <div className="ppvx_col-sm-12">
          <p
            className="ppvx_text--xl2 ppvx_text--regular"
            style={{ textAlign: 'center' }}
          >
            {payCreditOrDebit}
          </p>
        </div>
      </div>
    );
  }
}

DebitOrCredit.propTypes = {
  label: PropTypes.string,
};

export default DebitOrCredit;
